import React from "react";

const GatePayLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
    >
      <g opacity="0.3">
        <path
          d="M80 123.457C55.6321 123.457 36.1431 103.968 36.1431 79.6C36.1431 55.2321 55.6321 35.743 80 35.743V0C35.7343 0 0 35.7343 0 80C0 124.266 35.7343 160 80 160C124.266 160 160 124.266 160 80H124.266C123.857 103.959 104.368 123.457 80 123.457Z"
          fill="#14141E"
        />
        <path d="M123.857 35.7357H80V79.5927H123.857V35.7357Z" fill="#888888" />
      </g>
    </svg>
  );
};

export default GatePayLogo;
